export const AU_SEARCHADDRESS = "DataTools.Capture.Address.Predictive.AuPaf.SearchAddress";
export const AU_RETRIEVEADDRESS = "DataTools.Capture.Address.Predictive.AuPaf.RetrieveAddress";
export const AU_REPAIRAADDRESS = "DataTools.Repair.Address.AuPaf.RepairAddress"

export const NZ_SEARCHADDRESS = "DataTools.Capture.Address.Predictive.NzPaf.SearchAddress";
export const NZ_RETRIEVEADDRESS = "DataTools.Capture.Address.Predictive.NzPaf.RetrieveAddress";
export const NZ_REPAIRADDRESS = "DataTools.Verify.Address.NzPaf.VerifyAddress";